import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import { CategoriesReducer } from '../../models/Redux';
import { getAllCategories } from '../../services/CategoryService';

export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_LOADING_CATEGORIES = 'SET_LOADING_CATEGORIES';
export const ERROR_FETCHING_CATEGORIES = 'ERROR_FETCHING_CATEGORIES';

export const thunkGetAllCategories = (
    callback?: () => void,
): ThunkAction<void, CategoriesReducer, unknown, Action<string>> => dispatch => {
    dispatch({ type: SET_LOADING_CATEGORIES, payload: true });
    getAllCategories()
        .then(payload => {
            dispatch({
                type: SET_CATEGORIES,
                payload,
            });
            callback?.();
        })
        .catch(() => dispatch({ type: ERROR_FETCHING_CATEGORIES }));
};
